import { render } from "./Carrusel.vue?vue&type=template&id=711f3dde&scoped=true"
import script from "./Carrusel.vue?vue&type=script&lang=js"
export * from "./Carrusel.vue?vue&type=script&lang=js"

import "./Carrusel.vue?vue&type=style&index=0&id=711f3dde&scoped=true&lang=css"

import exportComponent from "/home/raulgarcia/Escritorio/projects/Vue/capwashmx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711f3dde"]])

export default __exports__